export { default } from './fbPixel'
export { default as getCampaignPixels } from './getCampaignPixel'
